import type { ResourceProfileRebuildStatus } from "../types";

/** 格式化资源画像重算任务状态。 */
export function formatResourceProfileRebuildStatus(status: ResourceProfileRebuildStatus): string {
  if (status === "planned") {
    return "已预览";
  }
  if (status === "completed") {
    return "已完成";
  }
  if (status === "failed") {
    return "执行失败";
  }
  return "已阻止";
}
